import head from 'lodash/head';
import isEmpty from 'lodash/isEmpty';

export const lastNote = notes => head(notes.sort((a, b) => a.created - b.created));

export const isNotificationMarker = (notes, currentUser, caseManagerId) => {
  const { name, surname, username } = currentUser;

  if (isEmpty(notes)) return false;
  if (caseManagerId !== username) return false;

  const note = lastNote(notes);
  const { generatedBy } = note;

  return generatedBy !== `${name} ${surname}`;


};
